<template>
<transition appear @leave="leave">
  <a-plane color="#fff" material="shader: flat" width="8" height="8" opacity="1">
    <a-image
      v-for="index in [1, 2, 3]"
      ref="images_intro"
      :src="cdn(require('./img/loading-' + index + '-' + lang + '.png'))"
      height=".5" :width=".5"
      :key="'image_' + index"
      :opacity="0"
      shader="flat" position="0 0 .001"
      @materialtextureloaded="elLoaded"
    />
  </a-plane>
</transition>
</template>

<script>
import Settings from '@/config/Settings'

export default {
  name: 'Load',
  data: () => ({
    elsLoaded: 0
  }),
  watch: {
    elsLoaded(){
      if(this.elsLoaded === 3)
        this.enter()
    }
  },
  methods: {
    elLoaded() {
      this.elsLoaded++
    },
    enter() {
      const tl = new TimelineMax()
      _.each(this.$refs.images_intro, i => {
        tl
          .to(i, 1, { aframe: {alpha: 1 }})
          .set({}, { delay: 2 })
          .to(i, 1, { aframe: {alpha: 0 }})
      })

      tl
        .to({}, .5, {})
        .call(() => this.$router.push({ name: 'infos.' + this.lang }))

      if(Settings.fast)
        tl.timeScale(10)

      this.$tl = tl
    },
    leave(el, done) {
      if(this.$tl)
        this.$tl.kill()

      const tl = new TimelineLite({ onComplete: done })
      .to([this.$el, this.$refs.images_intro], 2, { delay: 1, aframe: { alpha: 0 }})
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/load/Load.vue